import { render, staticRenderFns } from "./SapAdvantage.vue?vue&type=template&id=1a779786&scoped=true&"
import script from "./SapAdvantage.vue?vue&type=script&lang=js&"
export * from "./SapAdvantage.vue?vue&type=script&lang=js&"
import style0 from "./SapAdvantage.vue?vue&type=style&index=0&id=1a779786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a779786",
  null
  
)

export default component.exports